import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import notify from '@scoutgg/ftw/source/services/notification'
import '@scoutgg/ftw/source/atoms/form-control/form-control'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import query from '../../services/query'
import template from './transfers.jade'
import { Season, TeamSource } from '../../models'
import '../seasons'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('to-season', Season)
class Transfers extends HTMLElement {
  async attached() {
    const { seasons } = await Season.load({ active: true })
    this.applyState({ seasons })
    this.reload()
  }

  uncache() {
    this.$cached = null
    this.render()
  }

  seasonChange() {
    this.reload()
  }

  changeSeason({ season }, prop) {
    query({ [prop]: season })
  }

  async reload() {
    const { season, toSeason } = this
    if(!(season || toSeason)) return

    const data = await Promise.all([season, toSeason].map(s => {
      return s && TeamSource.load({ season: s._id })
    }))

    const sport = season?.league?.sport || toSeason?.league?.sport
    const isEsport = ['lol', 'dota2', 'csgo'].includes(sport)
    if(isEsport) {
      this.applyState({
        fromTeams: data[0]?.teams,
        toTeams: data[1]?.teamSources,
      })
    } else {
      this.applyState({
        fromTeams: data[0]?.teams,
        toTeams: data[1]?.teams,
      })
    }
  }

  updateFilter(e) {
    this.search = e.target.value
    this.render()
  }

  getTeams(scope) {
    let teams = this[`${scope}Teams`] || []
    if(this.search) {
      const search = this.search
        .split(',')
        .map(part => new RegExp(part, 'i'))
      teams = teams.filter(t => search.every(part => part.test(t.name)))
    }
    return teams
  }

  isSelected(team) {
    return (this.selected || {})[team]
  }

  toggle(team, state) {
    if(!this.selected) this.selected = {}
    state = state == null ? !this.selected[team] : state
    if(state) {
      this.selected[team] = true
    } else {
      delete this.selected[team]
    }
    this.render()
  }

  toggleAll() {
    const state = this.allTeamsSelected
    this.getTeams('from').forEach(t => this.toggle(t, !state))
  }

  async save() {
    if(!this.canSubmit) return
    const teams = Object.keys(this.selected)
    this.$isSubmitting = true
    await this.season.post('transfer', {
      toSeason: this.toSeason._id,
      teams: teams,
    }).catch(err => {
      notify(err.message, { level: 'danger', timeout: 10000 })
      console.error(err)
      this.render()
      this.$isSubmitting = false
      throw err
    })
    this.$isSubmitting = false
    notify('Teams & players copied', { level: 'success', timeout: 5000 })
    await this.reload()
    this.render()
  }

  changeSport(sport) {
    this.sport = sport || null
    this.render()
  }

  get activeSeasons() {
    const active = (this.seasons || []).filter((s) => s.active)
    return Array.from(new Set(active.map(season => season.sport))).sort()
  }

  get canSubmit() {
    return !this.$isSubmitting &&
      Object.keys(this.selected || {}).length &&
      this.season &&
      this.toSeason &&
      this.season !== this.toSeason
  }

  get allTeamsSelected() {
    return Object.keys(this.selected || {}).length ===
      this.getTeams('from').length
  }
}

export default Transfers
